import { DialogUI } from '../Interface';
import { useEffect, useState } from 'react';
import { useResourceOne } from '../../hooks/useResourceOne';
import { ResourceOnePage } from '../Resources/NewResourceOne/ResourceOnePage';

const RecruitmentCalendarDialog = ({ open, handleClose, changed, data }) => {
  const { dataChanged, setDataChanged } = changed;
  const resourceOneState = useResourceOne();
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    if (data) {
      resourceOneState.setSelectedValues(data);
      setIsUpdate(true);
    }
  }, [data, resourceOneState]);

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent={data?.name}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <div className="mt-5">
        <ResourceOnePage
          dialog={{
            handleClose: handleClose,
            taskChanged: dataChanged,
            setTaskChanged: setDataChanged,
            isUpdate: isUpdate,
          }}
          resourceOneState={resourceOneState}
        />
      </div>
    </DialogUI>
  );
};

export default RecruitmentCalendarDialog;
